import IconCard from "components/DynamicComponent/atoms/IconCard"
import useHasIntersected from "utilities/useHasIntersected"

export default function IconCardGridSection({ blok }) {
  const { ref, isIntersecting } = useHasIntersected()

  return (
    <section className="bg-springWood px-6">
      <div className="mx-auto max-w-screen-xl py-10 lg:py-16">
        <h2 className="mb-20 text-center font-medium text-teal-dark">{blok.heading}</h2>
        <div className="flex flex-col flex-wrap justify-between gap-6 md:grid-cols-2 lg:grid-cols-4 lg:flex-row">
          {blok.icon_cards.map((card) => (
            <IconCard key={card._uid} blok={card} />
          ))}
        </div>
      </div>
    </section>
  )
}
